import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import { DrawerWrapper, TitleWrapper } from "../styles";
import useLanguage from "../../../hooks/useLanguage";
import ArticleIcon from "@mui/icons-material/Article";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import SwipeVerticalIcon from "@mui/icons-material/SwipeVertical";
import styled from "styled-components";

const CONTENT_TYPE_CONFIG = {
  article: { icon: <ArticleIcon />, color: "#46A0E1" },
  "content-creator": { icon: <AccountTreeIcon />, color: "#E1A946" },
  "video-content-creator": { icon: <OndemandVideoIcon />, color: "#46E19B" },
  reframer: { icon: <SwipeVerticalIcon />, color: "#9B46E1" },
};

const TypeListItem = styled(ListItem)`
  cursor: pointer;
  min-width: 200px;
`;

const TypeListItemText = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== "$rtl",
})`
  text-align: ${({ $rtl }) => ($rtl ? "right" : "left")};
`;

export default function ContentTypeDrawer({ onClose, onClick }) {
  const [
    {
      direction,
      pages: {
        content: { drawer: text },
      },
    },
  ] = useLanguage();

  return (
    <DrawerWrapper>
      <TitleWrapper>
        <Box>
          <Typography variant="h5">{text.title}</Typography>
          <Typography variant="caption">{text.description}</Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      </TitleWrapper>
      <Divider />

      <List>
        {text.types.map((type) => (
          <TypeListItem
            onClick={() => onClick(type?.id)}
            key={type.id}
            button
            id={type.id}
            divider
          >
            <ListItemAvatar>
              <Avatar
                style={{ backgroundColor: CONTENT_TYPE_CONFIG[type.id]?.color }}
              >
                {CONTENT_TYPE_CONFIG[type.id]?.icon}
              </Avatar>
            </ListItemAvatar>
            <TypeListItemText
              primary={type.title}
              secondary={type.description}
              $rtl={direction === "rtl"}
            />
          </TypeListItem>
        ))}
      </List>
    </DrawerWrapper>
  );
}
